import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { LoadingOverlay } from '../../../components';
import { useUser } from '../../../hooks';
import { AuthPath, AuthSearch } from '../models';
import { getTo } from '../utils';

const RequireUser: FunctionComponent = ({ children }) => {
  const user = useUser();

  if (user === undefined) {
    return <LoadingOverlay isFullPage in />;
  } else if (user === null) {
    return <Redirect to={getTo(AuthPath.Login, `${AuthSearch.ReturnTo}=${window.location.pathname}`)} />;
  } else {
    return <>{children}</>;
  }
};

export default RequireUser;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/components/RequireUser.tsx